import BaseRestEntity from '@/common/entities/base-rest-entity'

export default class Admin extends BaseRestEntity {
  public firstName = ''
  public lastName = ''
  public email = ''
  public password = ''
}
